"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FavoriteRoute {
    static get path() {
        return '/favorite';
    }
    static get friendlyName() {
        return 'favoritesHeader';
    }
}
exports.default = FavoriteRoute;
